<template>
  <img
      class="logo pt-4 pb-2 ml-4"
      src="./S1-MME-logo.svg"
      alt="society one logo"
  />
</template>

<script>
export default {
  name: 'Logo',
};
</script>



// WEBPACK FOOTER //
// src/assets/Logo.vue